export function buildSchema(ruleTypeStore, ruleType, defaultValue, widget, label, selectedCountryCode) {
  switch (widget) {
    case "select":
      return buildSelect(ruleTypeStore, ruleType, defaultValue, selectedCountryCode);
    case "dateTime":
      return buildDateTime(label);
    case "string":
      return {
        type: "string", title: label, default: defaultValue
      }
    default:
      break
  }
}

function buildDateTime(label) {
  const defaultValue = new Date().toISOString();
  return {
    type: "string", title: label, format: "date-time", default: defaultValue
  }
}

function buildSelect(ruleTypeStore, ruleType, defaultValue, selectedCountryCode) {
  const rule = ruleTypeStore.ruleTypes.find((rule) => rule.uuid === ruleType)
  if (!rule) return

  const enumArray = []
  const enumNames = []
  let values = JSON.parse(rule?.data)?.values || []

  const mappings = {
    city: {valueKey: "cityName", nameKey: "cityName"},
    countryRegion: {valueKey: "stateCode", nameKey: "stateName"},
    default: {valueKey: "code", nameKey: "name"},
  };
  const {valueKey, nameKey} = mappings[ruleType] || mappings.default;


  if (ruleType === "city" || ruleType === "countryRegion") {
    values = values.filter((value) => value?.countryCode === selectedCountryCode)
  }

  values = values.sort((a, b) => a?.[valueKey].localeCompare(b?.[valueKey]))

  values.forEach((value) => {
    enumArray.push(value?.[valueKey]);
    enumNames.push(value?.[nameKey]);
  });
  return {
    type: "string", title: rule?.label, enum: enumArray, enumNames: enumNames, default: defaultValue
  }
}

